import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import { withStyles } from 'Components/ComponentLibrary/ExternalLibraries/Libraries/MaterialV4/styles';
import MetaCollectionFormInline from 'Components/UI/Meta/MetaForm/MetaCollectionFormInline';

const styles = () => ({
  root: {
    padding: 0,
    margin: 0,
  },
  form: {
    padding: 0,
  },
});

const AuthenticationForm = ({
  className,
  classes,
  layout,
  collection,
  metaOverrideSet,
  test,
}) => {
  return (
    <MetaCollectionFormInline
      classes={{
        root: classNames(classes.root, className),
        form: classes.form,
      }}
      collection={collection}
      metaOverrideSet={metaOverrideSet}
      FormProps={{
        test,
        layout,
        LayoutProps: {
          onlyUnsourcedErrors: true,
          showRemainingFieldList: false,
          hideErrorList: true,
        },
        readonly: true, // <--- Hides default Submit button
      }}
    />
  );
};

AuthenticationForm.defaultProps = {
  className: '',
  layout: null,
  metaOverrideSet: null,
};

AuthenticationForm.propTypes = {
  className: PropTypes.string,
  classes: PropTypes.object.isRequired,
  layout: PropTypes.oneOfType([PropTypes.object, PropTypes.func]),
  metaOverrideSet: PropTypes.object,
  collection: PropTypes.object.isRequired,
  test: PropTypes.string.isRequired,
};

export default withStyles(styles)(AuthenticationForm);
